// packages/web/src/components/learner/LearnerWelcome.tsx
// Reemplaza el JSX de la fase 'ready' en LearnerEntry. Solo presentación.
import { ArrowRight, Clock, Mic, PenLine, Target, Loader2 } from 'lucide-react';
import type { Modality } from '../../types';
import { GuideAvatar, MODALITY_KID, Wordmark, firstName } from './ui';

export interface LearnerWelcomeProps {
  studentName: string;
  asignatura: string;
  oasCount: number;
  modality: Modality;
  tiempoEstimado: string;
  starting?: boolean;
  onStart: () => void;
}

export function LearnerWelcome(p: LearnerWelcomeProps) {
  const ModIcon = p.modality === 'written' ? PenLine : Mic;
  const tiles = [
    { Icon: Clock, value: p.tiempoEstimado, label: 'tiempo' },
    { Icon: ModIcon, value: MODALITY_KID[p.modality], label: 'modalidad' },
    { Icon: Target, value: p.oasCount === 1 ? '1 objetivo' : `${p.oasCount} objetivos`, label: 'tema' },
  ];
  const name = firstName(p.studentName);

  return (
    <main className="flex min-h-[100dvh] flex-col bg-crema font-kid text-slate-900">
      <div className="mx-auto flex w-full max-w-[640px] flex-1 flex-col gap-5 px-5 pt-6">
        <Wordmark />
        <section className="flex flex-col items-center gap-3.5 pt-3 text-center">
          <GuideAvatar size={104} />
          <h1 className="text-[34px] font-bold text-marzano-600">¡Hola{name ? `, ${name}` : ''}!</h1>
          <p className="text-pretty text-[19px] leading-snug text-slate-700">
            Soy Pío. Vamos a conversar sobre lo que aprendiste en <strong>{p.asignatura}</strong>.
          </p>
        </section>

        <ul className="grid grid-cols-3 gap-2">
          {tiles.map(({ Icon, value, label }) => (
            <li key={label} className="flex flex-col items-center gap-1 rounded-[18px] bg-white px-2 py-3.5 text-center">
              <Icon aria-hidden className="h-6 w-6 text-marzano-600" />
              <strong className="text-base leading-tight">{value}</strong>
              <span className="text-sm text-slate-600">{label}</span>
            </li>
          ))}
        </ul>

        <section className="card-kid flex flex-col gap-3 px-[18px] py-4">
          <h2 className="text-[17px] font-bold">¿Cómo funciona?</h2>
          <ol className="flex flex-col gap-3 text-[17px]">
            {['Pío te hace preguntas.', 'Respondes con tus palabras, sin apuro.', 'Al final ves cómo te fue.'].map((t, i) => (
              <li key={t} className="flex items-center gap-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-marzano-50 font-bold text-marzano-600">{i + 1}</span>
                {t}
              </li>
            ))}
          </ol>
        </section>
      </div>

      <div className="sticky bottom-0 bg-crema px-5 pb-[max(28px,env(safe-area-inset-bottom))] pt-4">
        <button type="button" onClick={p.onStart} disabled={p.starting}
          className="btn-kid mx-auto h-[60px] w-full max-w-[640px] bg-marzano-600 text-xl text-white hover:bg-marzano-700 disabled:opacity-60">
          {p.starting ? <><Loader2 aria-hidden className="h-6 w-6 animate-spin" />Preparando…</> : <>Empezar <ArrowRight aria-hidden className="h-6 w-6" /></>}
        </button>
      </div>
    </main>
  );
}
